// Phase 7 - US5: Analytics Types (T127)

export interface ResponseDistribution {
  questionId: string;
  questionText: string;
  questionType: string;
  totalResponses: number;
  distribution: {
    [key: string]: number;
  };
}

export interface DemographicBreakdown {
  category: string;
  value: string;
  count: number;
  percentage: number;
}

export interface CollectionPeriod {
  startDate: string;
  endDate: string;
  isActive: boolean;
}

export interface QuantitativeAnalytics {
  surveyId: string;
  surveyName: string;
  status: string;
  totalResponses: number;
  collectionPeriod: CollectionPeriod;
  message?: string;
}

export interface QualitativeAnalytics extends QuantitativeAnalytics {
  responseDistribution: ResponseDistribution[];
  demographicBreakdown: {
    gender: DemographicBreakdown[];
    ageGroup: DemographicBreakdown[];
    education: DemographicBreakdown[];
    economicLevel: DemographicBreakdown[];
    city: DemographicBreakdown[];
  };
}

export type AnalyticsData = QuantitativeAnalytics | QualitativeAnalytics;

export function isQualitativeAnalytics(
  data: AnalyticsData
): data is QualitativeAnalytics {
  return 'responseDistribution' in data;
}
